import { cn } from "@/lib/utils";

const LABELS: Record<string, string> = {
  connection: "Närhet",
  movement: "Rörelse",
  recovery: "Återhämtning",
  gratitude: "Tacksamhet",
  meaning: "Mening",
  presence: "Närvaro",
};

const ORDER = [
  "recovery",
  "presence",
  "connection",
  "movement",
  "gratitude",
  "meaning",
] as const;

export function CategoryHeat({
  categories,
}: {
  categories: Array<{ category: string; count: number }>;
}) {
  const max = Math.max(1, ...categories.map((c) => c.count));
  const map = new Map(categories.map((c) => [c.category, c.count]));

  return (
    <div className="grid grid-cols-3 gap-2.5">
      {ORDER.map((cat) => {
        const count = map.get(cat) ?? 0;
        const intensity = count === 0 ? 0 : 0.25 + (count / max) * 0.75;
        return (
          <div
            key={cat}
            className={cn(
              "rounded-2xl border border-border/50 px-3 py-3.5 text-center",
              count === 0 ? "bg-surface-muted/60" : "bg-primary-soft"
            )}
            style={
              count > 0
                ? { opacity: Math.min(1, 0.45 + intensity * 0.55) }
                : undefined
            }
          >
            <div className="text-[11px] font-medium text-foreground-muted">
              {LABELS[cat] ?? cat}
            </div>
            <div className="mt-1 text-lg font-semibold tracking-tight text-foreground [font-family:var(--font-display)]">
              {count}
            </div>
          </div>
        );
      })}
    </div>
  );
}
